import React, { useEffect } from 'react';
import AdvisoryAppShell from '../../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryAppShell';
import OffersSidebar from '../components/sidebar/OffersSidebar';
import { Redirect, Route, Switch } from 'react-router-dom';
import SelectedOffers from './selected-offers';
import OffersSidebarMobile from '../components/sidebar/mobile/OffersSidebarMobile';
import OffersOverview from './offers-overview';
import { useFlowsSession } from '../../../../../flows/src/api/getFlowsSessionById';
import useSessionId from '../../../../../flows/src/hooks/useSessionId';
import LoadingScreen from '../../../../../common/src/components/LoadingScreen';
import { setSelectionState } from '../../../utils/persistUtils';
import LoadingSpinner from '../../../../../common/src/components/LoadingSpinner';

export const Offers: React.FC = () => {
  const sessionId = useSessionId();
  const { data: flowsSession, isLoading } = useFlowsSession(sessionId);

  // This is a temporary solution
  // In theory the selection state should no longer be needed
  // Server data should be the only source of truth !!!
  useEffect(() => {
    if (flowsSession) {
      setSelectionState(sessionId, {
        insurance_type: flowsSession.insurance_types,
        company: flowsSession.companies,
        car_tag: flowsSession.car_tags,
        home_tag: flowsSession.home_tags,
        family_tag: flowsSession.family_tags,
        legal_tag: flowsSession.legal_tags,
      });
    }
  }, [flowsSession]);

  if (isLoading) return <LoadingScreen />;

  return (
    <AdvisoryAppShell
      toolbarContent={<OffersSidebar />}
      mobileToolbarContent={<OffersSidebarMobile />}
    >
      <Switch>
        <Route
          path="/sales-conversation/offers/overview/default"
          exact
          component={OffersDefaultRedirect}
        />
        <Route
          path="/sales-conversation/offers/overview/:riskObject"
          component={OffersOverview}
        />
        <Route
          path="/sales-conversation/offers/selected-offers"
          component={SelectedOffers}
        />
      </Switch>
    </AdvisoryAppShell>
  );
};

const OffersDefaultRedirect: React.FC = () => {
  const sessionId = useSessionId();
  const { data: flowsSession } = useFlowsSession(sessionId || '');

  if (flowsSession?.insurance_types[0])
    return (
      <Redirect
        to={`/sales-conversation/offers/overview/${flowsSession.insurance_types[0]}?session_id=${sessionId}`}
      />
    );
  return <LoadingSpinner />;
};

export default Offers;
